export default {"src":"/_next/static/media/close.c1f8bbb6.svg","height":192,"width":192};